module.exports = __webpack_public_path__ + "media/images/forms-icons/bmi-icon-hover-1707180f7addae9de56cc96af9dd9a08.svg";